import moment from 'moment';
import { css } from 'glamor';
import * as PortfolioConstants from './constants';
import { DATE_FORMAT, REQUEST_DATE_FORMAT } from '../../constants';
export const appliedPortfolioFilters = (filterFormData, toDate, fromDate) => {
    let appliedFilters = [];
    counterPartyNameFilter(filterFormData, appliedFilters);
    riskLevelFilter(filterFormData, appliedFilters);
    zoneFilter(filterFormData, appliedFilters);
    productNameFilters(filterFormData, appliedFilters);
    legalContitutionFilters(filterFormData, appliedFilters);
    businessSegmentsFilters(filterFormData, appliedFilters);
    caseStatusFilters(filterFormData, appliedFilters);
    riskTrendFilters(filterFormData, appliedFilters);
    if (toDate && fromDate) {
        appliedFilters.push({
            date: [
                {
                    label: moment(toDate).format(DATE_FORMAT),
                    key: PortfolioConstants.TO_DATE
                },
                {
                    label: moment(fromDate).format(DATE_FORMAT),
                    key: PortfolioConstants.FROM_DATE
                },
            ]
        });
    }
    return appliedFilters;
}

const counterPartyNameFilter = (filterFormData, appliedFilters) => {
    if (filterFormData.counterpartyFilter) {
        filterFormData.counterpartyFilter.forEach((item, index, element) => {
            appliedFilters.push(item)
        })
    }
}
const riskLevelFilter = (filterFormData, appliedFilters) => {
    if (filterFormData.riskLevelFilter) {
        filterFormData.riskLevelFilter.forEach((item, index, element) => {
            appliedFilters.push(item)
        })
    }
}
const zoneFilter = (filterFormData, appliedFilters) => {
    if (filterFormData.zoneFilter) {
        filterFormData.zoneFilter.forEach((item, index, element) => {
            appliedFilters.push(item)
        })
    }
}
const productNameFilters = (filterFormData, appliedFilters) => {
    if (filterFormData.productNameFilter) {
        filterFormData.productNameFilter.forEach((item, index, element) => {
            appliedFilters.push(item)
        })
    }
}

const legalContitutionFilters = (filterFormData, appliedFilters) => {
    if (filterFormData.legalConstitutionFilter) {
        filterFormData.legalConstitutionFilter.forEach((item, index, element) => {
            appliedFilters.push(item)
        })
    }
}

const businessSegmentsFilters = (filterFormData, appliedFilters) => {
    if (filterFormData.businessSegmentFilter) {
        filterFormData.businessSegmentFilter.forEach((item, index, element) => {
            appliedFilters.push(item)
        })
    }
}
const caseStatusFilters = (filterFormData, appliedFilters) => {
    if (filterFormData.caseStatusFilter) {
        filterFormData.caseStatusFilter.forEach((item, index, element) => {
            appliedFilters.push(item)
        })
    }
}
const riskTrendFilters = (filterFormData, appliedFilters) => {
    if (filterFormData.riskScoreTrendFilter) {
        filterFormData.riskScoreTrendFilter.forEach((item, index, element) => {
            appliedFilters.push(item)
        })
    }
}

export const filterValueListRemove = (removeFilter, appliedFilterList) => {
    appliedFilterList.forEach((item, index, element) => {
        if (item === removeFilter) {
            appliedFilterList.splice(index, 1)
        }
    })
    return appliedFilterList
}

export const deleteAppliedFilterList = (removeFilter, appliedFilters, toDate, fromDate) => {
    deleteCounterPartyFilter(removeFilter, appliedFilters);
    deleteReportTypeFilter(removeFilter, appliedFilters);
    deleteRiskLevelFilter(removeFilter, appliedFilters);
    deleteZoneFilter(removeFilter, appliedFilters);
    deleteProductNameFilter(removeFilter, appliedFilters);
    deleteLegalConstitutionFilter(removeFilter, appliedFilters);
    deleteBusinessSegment(removeFilter, appliedFilters);
    deleteRiskTrendFilter(removeFilter, appliedFilters);
    deleteCaseStatusFilter(removeFilter, appliedFilters);
    if (toDate || fromDate) {
        deleteDateFilter(appliedFilters)
    }

    return appliedFilters
}

const deleteDateFilter = (appliedFilters) => {
    appliedFilters.toDate = null;
    appliedFilters.fromDate = null;
}
const deleteCounterPartyFilter = (removeFilter, appliedFilters) => {
    appliedFilters.counterpartyFilter.filter((currentValue, index, element) => {
        if (currentValue === removeFilter) {
            return element.splice(index, 1);
        }
    })
}
const deleteReportTypeFilter = (removeFilter, appliedFilters) => {
    appliedFilters.productNameFilter.filter((currentValue, index, element) => {
        if (currentValue === removeFilter) {
            return element.splice(index, 1)
        }
    })
}
const deleteRiskLevelFilter = (removeFilter, appliedFilters) => {
    appliedFilters.riskLevelFilter.filter((currentValue, index, element) => {
        if (currentValue === removeFilter) {
            return element.splice(index, 1);
        }

    })
}
const deleteZoneFilter = (removeFilter, appliedFilters) => {
    appliedFilters.zoneFilter.filter((currentValue, index, element) => {
        if (currentValue === removeFilter) {
            return element.splice(index, 1);
        }
    })
}
const deleteProductNameFilter = (removeFilter, appliedFilters) => {
    appliedFilters.productNameFilter.filter((currentValue, index, element) => {
        if (currentValue === removeFilter) {
            return element.splice(index, 1);
        }
})
}
const deleteLegalConstitutionFilter = (removeFilter, appliedFilters) => {
    appliedFilters.legalConstitutionFilter.filter((currentValue, index, element) => {
        if (currentValue === removeFilter) {
            return element.splice(index, 1);
        }
    })
}
const deleteBusinessSegment = (removeFilter, appliedFilters) => {
    appliedFilters.businessSegmentFilter.filter((currentValue, index, element) => {
        if (currentValue === removeFilter) {
            return element.splice(index, 1);
        }
    })
}
const deleteRiskTrendFilter = (removeFilter, appliedFilters) => {
    appliedFilters.riskScoreTrendFilter.filter((currentValue, index, element) => {
        if (currentValue === removeFilter) {
            return element.splice(index, 1);
        }
    })
}
const deleteCaseStatusFilter = (removeFilter, appliedFilters) => {
    appliedFilters.caseStatusFilter.filter((currentValue, index, element) => {
        if (currentValue === removeFilter) {
            return element.splice(index, 1);
        }
    })
}
export const portfolioDataHandle = (portfolioData) => {
    let tempPortfolioData = [], riskTrend, riskLevel;
    portfolioData.forEach((item, index, element) => {
        riskTrend = getRiskTrendClass(item);
        riskLevel = getRiskLevelClass(item);
        tempPortfolioData.push({
            counterpartyType: item.counterpartyType,
            id: item.computedReportId,
            counterpartyName: item.counterpartyName,
            counterpartyId: item.counterpartyId,
            riskScore: item.riskScore,
            riskScoreTrend: riskTrend,
            riskLevel: riskLevel,
            productName: item.productName,
            deliveryDate: item.deliveryDate,
            lastUpdateDate: item.lastUpdateDate,
            status: item.status,
            isChecked: false,
            zoneName: item.zoneName
        })
    })
    return tempPortfolioData
}

export const getRiskLevelClass = (portFolioRiskLevelData) => {
    switch (portFolioRiskLevelData.riskLevel) {
        case PortfolioConstants.HIGH:
            return 'risk-indicator-box high'
        case PortfolioConstants.LOW:
            return 'risk-indicator-box low'
        case PortfolioConstants.MEDIUM:
            return 'risk-indicator-box medium'
        default: return 'risk-indicator-box none'
    }
}
export const getRiskTrendClass = (portfolioRiskTrendData) => {
    switch (portfolioRiskTrendData.riskScoreTrend) {
        case PortfolioConstants.UP:
            return 'icon-chevron-up';
        case PortfolioConstants.DOWN:
            return 'icon-chevron-down';
        case PortfolioConstants.STABLE:
            return 'icon-minus-01';
        default: return 'ml-2'
    }
}

export const SearchRequestBody = (value, portfolioData, toDate, fromDate) => {
    let searchBody;
    if (toDate && fromDate) {
        toDate = moment(toDate).format(REQUEST_DATE_FORMAT); //DATE_FORMAT
        fromDate = moment(fromDate).format(REQUEST_DATE_FORMAT); //DATE_FORMAT
    }
    if (portfolioData.length === 0) {
        searchBody = {
            searchString: value,
            counterpartyFilter: [],
            productNameFilter: [],
            riskLevelFilter: [],
            zoneFilter: [],
            legalConstitutionFilter: [],
            businessSegmentFilter: [],
            caseStatusFilter: [],
            riskScoreTrendFilter: [],
            toDate: toDate,
            fromDate: fromDate
        }
    } else {
        searchBody = {
            ...portfolioData,
            toDate: toDate,
            fromDate: fromDate,
            searchString: value
        }
    }
    return searchBody
}

/* export const sortDataByKey = (key, portfolioSortableData, order) => {

    if (order) {
        portfolioSortableData.reverse(compareBy(key))
        portfolioSortableData.sort(compareBy(key));
    } else {
        portfolioSortableData.sort(compareBy(key))
        portfolioSortableData.reverse(compareBy(key));

    }
    return portfolioSortableData
}

const compareBy = (key) => {
    return function (a, b) {
        if (a[key] < b[key]) return 1;
        if (a[key] > b[key]) return -1;
        return 0;
    };
}

export const sortByDate = (key, portFolioDateSortableData, order) => {
    if (order) {
        sortDateAscendingOrder(key, portFolioDateSortableData)
    } else {
        sortDateDesendingOrder(key, portFolioDateSortableData)
    }
    return portFolioDateSortableData
}

const sortDateAscendingOrder = (key, portFolioDateSortableData) => {
    portFolioDateSortableData.reverse(function (a, b) {
        return new Date(b[key].date) - new Date(a[key].date);
    });
    portFolioDateSortableData.sort(function (a, b) {
        return new Date(b[key].date) - new Date(a[key].date);
    });;
    return portFolioDateSortableData
} */

const sortDateDesendingOrder = (key, portFolioDateSortableData) => {
    portFolioDateSortableData.sort(function (a, b) {
        return new Date(b[key].date) - new Date(a[key].date);
    });
    portFolioDateSortableData.reverse(function (a, b) {
        return new Date(b[key].date) - new Date(a[key].date);
    });
    return portFolioDateSortableData
}

export const checkAllCheckboxMethod = (portfolioData) => {
    let flag = true
    for (let i = 0; i < portfolioData.length; i++) {
        if (portfolioData[i].isChecked === false) {
            flag = false;
            break;
        } else {
            flag = true
        }
    }
    return flag
}

export const setCounterpartyList = (portfolioData) => {
    let tempCounterpartyList = []
    portfolioData.forEach(data => {
        if (data.isChecked === true) {
            return tempCounterpartyList.push(data.counterpartyId);
        }
    })

    return tempCounterpartyList;
}

export const setInitialValues = (dashboardFilters) => {
    let tempInitialValues = {}
    const tempCounterPartyInital = counterPartyInitialValues(dashboardFilters);
    const tempCaseStatusInitial = caseStatusInitialValues(dashboardFilters);
    const tempZoneInitial = zoneInitialValues(dashboardFilters);
    const templegalConstitutionInitial = legalContitutionInitialValues(dashboardFilters);
    const tempProductNameInitial = productNameInitialValues(dashboardFilters);
    const tempRiskTrendInitial = riskTrendInitialValues(dashboardFilters);
    const tempRiskLevelInitial = riskLevelInitialValues(dashboardFilters);
    const tempBusinessSegmentInitial = businessSegmentInitialvalues(dashboardFilters);
    tempInitialValues = Object.assign({},
        tempCounterPartyInital,
        tempCaseStatusInitial,
        tempZoneInitial,
        templegalConstitutionInitial,
        tempProductNameInitial,
        tempRiskTrendInitial,
        tempRiskLevelInitial,
        tempBusinessSegmentInitial
    )
    return tempInitialValues;
}

const counterPartyInitialValues = (dashboardFilters) => {
    let tempCounterPartyFilter = {}
    if (dashboardFilters.counterpartyFilter) {
        dashboardFilters.counterpartyFilter.forEach((item, index, element) => {
            return tempCounterPartyFilter[item] = true
        })
    }
    return tempCounterPartyFilter
}
const caseStatusInitialValues = (dashboardFilters) => {
    let tempCaseStatusFilter = {}
    if (dashboardFilters.caseStatusFilter) {
        dashboardFilters.caseStatusFilter.forEach((item, index, element) => {
            return tempCaseStatusFilter[item] = true
        })
    }
    return tempCaseStatusFilter
}
const zoneInitialValues = (dashboardFilters) => {
    let tempZoneFilter = {}
    if (dashboardFilters.zoneFilter) {
        dashboardFilters.zoneFilter.forEach((item, index, element) => {
            return tempZoneFilter[item] = true
        })
    }
    return tempZoneFilter
}

const legalContitutionInitialValues = (dashboardFilters) => {
    let tempLegalContitutionFilter = {}
    if (dashboardFilters.legalConstitutionFilter) {
        dashboardFilters.legalConstitutionFilter.forEach((item, index, element) => {
           return tempLegalContitutionFilter[item] = true
        })
    }
    return tempLegalContitutionFilter
}
const productNameInitialValues = (dashboardFilters) => {
    let tempProductNameFilter = {}
    if (dashboardFilters.productNameFilter) {
        dashboardFilters.productNameFilter.forEach((item, index, element) => {
           return tempProductNameFilter[item] = true
        })
    }
    return tempProductNameFilter
}
const riskTrendInitialValues = (dashboardFilters) => {
    let tempRiskScoreTrendFilter = {}
    if (dashboardFilters.riskScoreTrendFilter) {
        dashboardFilters.riskScoreTrendFilter.forEach((item, index, element) => {
            return tempRiskScoreTrendFilter[item] = true
        })
    }
    return tempRiskScoreTrendFilter
}
const riskLevelInitialValues = (dashboardFilters) => {
    let tempRiskLevelFilter = {}
    if (dashboardFilters.riskLevelFilter) {
        dashboardFilters.riskLevelFilter.forEach((item, index, element) => {
            return tempRiskLevelFilter[item] = true
        })
    }
    return tempRiskLevelFilter
}
const businessSegmentInitialvalues = (dashboardFilters) => {
    let tempBusinessSegmentFilter = {}
    if (dashboardFilters.businessSegmentFilter) {
        dashboardFilters.businessSegmentFilter.forEach((item, index, element) => {
            return tempBusinessSegmentFilter[item] = true
        })
    }
    return tempBusinessSegmentFilter
}

export const checkDuplicateCounterParty = (selectedPortfolioData) => {
    return selectedPortfolioData.map((e) => {
        return e.counterpartyType
    }).every(checkCounterPartyTypeDuplicate)
}

function checkCounterPartyTypeDuplicate(selectedCounterpartyType, index, selectedPortfolioData) {
    return (selectedCounterpartyType === selectedPortfolioData[0])
}
export const checkDuplicateZone = (selectedPortfolioData) => {
    return selectedPortfolioData.map((e) => {
        return e.zoneName
    }).every(checkZoneDuplicate)
}

function checkZoneDuplicate(selectedZone, index, selectedPortfolioData) {
    return (selectedZone === selectedPortfolioData[0])
}

export const paginatedRequestBody = (pageNo, pageSize, sortField, sortType, filters) => {
    return {
        paginateData: {
            pageNo: pageNo,
            pageSize: pageSize,
            sortField: sortField,
            sortType: sortType
        },
        requestData: filters
    }
}
export const pageLink = css({
    margin: '5px',
    display: 'inline-block',
    padding: '10px',
    WebkitBorderRadius: '20px',
    MozBorderRadius: '20px',
    borderRadius: '0px',
    textTransform: 'capitalize',
})

export const currentLink = css({
    backgroundColor: '#dceaf9',
    display: 'inline-block',
    color: '#FFFFFF',
    'a:link': { color: '#FFFFFF' },
    'a:visited': { color: '#FFFFFF' },
    'a:active': { color: '#FFFFFF' }
})